import React from "react";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import useTheme from "../../hooks/useTheme";
import { PlatformType } from "../../types/types";
import useStyles from "../../hooks/useStyles";

export default function Apple(props: {
  minVersion?: string | number;
  style?: React.CSSProperties;
}) {
  const { isSmallLayout } = useWindowDimensions();
  const theme = useTheme();

  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <img
        src={theme.images.apple}
        style={isSmallLayout ? useStyles.iconSmall : useStyles.iconLarge}
        alt={PlatformType.iOS}
      />
      <h3>{props?.minVersion}</h3>
    </div>
  );
}
